// BS4 modal handling

var fn_modal_bs = function () {

  function modal_alert_backdrop () {
    $('body').children('.modal-backdrop').addClass('modal-backdrop--faded');
    $('body').addClass('modal-open--faded');
  }
  function modal_alert_backdrop_clear () {
    $('body').children('.modal-backdrop').removeClass('modal-backdrop--faded');
    $('body').removeClass('modal-open--faded');
  }
  var toggler = $('.btn--alert.share-tools__btn .share-tools__label');

  // > Alert
  // > Alert modal - On
  $('#alert_modal').on('shown.bs.modal', function (e) {
    // $(this).children().find('.modal-header .btn.close').focus();
    $('body').removeClass('modal-open');
    // > get text for the button
    var btn = $(toggler).html();
    // > set text according to current text
    $(toggler).html(btn == "Masquer l'alerte" ? "Afficher l'alerte" : "Masquer l'alerte");
    // 
    $("html, body").animate({ scrollTop: 0 }, 1500);

  })
  // > Alert modal - OFF
  $('#alert_modal').on('hide.bs.modal', function (e) {
    // > get text for the button
    var btn = $(toggler).html();
    // > set text according to current text
    $(toggler).html(btn == "Masquer l'alerte" ? "Afficher l'alerte" : "Masquer l'alerte");
  })



  // > On
  $('.modal').on('shown.bs.modal', function (e) {
    $(this).children().find('.modal-header .btn.close').focus();
  })

  // > On Load
  $(window).on('load', function () {
    // $('#alert_modal').modal('show')
    // modal_alert_backdrop()
  })

};
